var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3049_7848)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.41943,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.76568,
    y: 1.34625,
    width: 27.3075,
    height: 27.3075,
    rx: 13.6538,
    stroke: "#D0D5DD",
    strokeWidth: 0.692494
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3049_7848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3221 8.07422H10.517C10.2459 8.07422 9.98582 8.18193 9.79408 8.37367C9.60234 8.56541 9.49463 8.82545 9.49463 9.09661V20.9017C9.49463 21.1729 9.60234 21.4329 9.79408 21.6246C9.98582 21.8164 10.2459 21.9241 10.517 21.9241H22.3221C22.5933 21.9241 22.8533 21.8164 23.0451 21.6246C23.2368 21.4329 23.3445 21.1729 23.3445 20.9017V9.09661C23.3445 8.82545 23.2368 8.56541 23.0451 8.37367C22.8533 8.18193 22.5933 8.07422 22.3221 8.07422ZM13.6227 19.8726H11.5404V13.2583H13.6227V19.8726ZM12.5801 12.3417C12.3439 12.3404 12.1134 12.2691 11.9176 12.1369C11.7219 12.0047 11.5697 11.8175 11.4803 11.5988C11.3909 11.3802 11.3682 11.14 11.4152 10.9085C11.4621 10.677 11.5766 10.4646 11.7442 10.2982C11.9117 10.1317 12.1248 10.0185 12.3566 9.97307C12.5884 9.92759 12.8285 9.9518 13.0465 10.0426C13.2646 10.1335 13.4508 10.2868 13.5818 10.4834C13.7127 10.68 13.7825 10.911 13.7823 11.1472C13.7845 11.3053 13.7549 11.4623 13.6952 11.6087C13.6355 11.7552 13.5469 11.8881 13.4347 11.9995C13.3225 12.111 13.189 12.1988 13.0422 12.2575C12.8954 12.3163 12.7382 12.345 12.5801 12.3417ZM21.2978 19.8784H19.2165V16.2649C19.2165 15.1992 18.7635 14.8703 18.1787 14.8703C17.5612 14.8703 16.9553 15.3358 16.9553 16.2918V19.8784H14.873V13.2631H16.8755V14.1797H16.9024C17.1034 13.7729 17.8074 13.0775 18.8818 13.0775C20.0436 13.0775 21.2988 13.7671 21.2988 15.7869L21.2978 19.8784Z",
    fill: "#0A66C2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3049_7848",
    x: 0.419434,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3049_7848"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3049_7848",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3049_7848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8499,
    height: 13.8499,
    fill: "white",
    transform: "translate(9.49463 8.07422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinI);
export default __webpack_public_path__ + "static/media/Linkdin-i.8f890d12126866059d9b415308ec3493.svg";
export { ForwardRef as ReactComponent };